
<main id='root' class='{{this.themeClass}}'>
    <router-outlet></router-outlet>
</main>